<template>
  <master-layout>
    <div id="session-material" class="lg:flex-1 lg:overflow-hidden mb-[24px]">
      <div
        class="session-bg w-full h-[200px] lg:flex-1 bg-repeat px-5 pt-[16px] bg-blue"
        :class="{
          'bg-session-card': isOrange,
          'bg-blue': isYellow,
          '!pt-[30px] !h-[240px]': isIos,
        }"
      >
        <div class="lg:flex flex flex-col lg:items-start">
          <div class="lg:flex-shrink-0">
            <div
              class="rounded-lg lg:w-64 cursor-pointer"
              data-test-id="gensapp-session-resources-back"
              @click="back()"
            >
              <img src="../../../../public/assets/icons/session-chevron.svg" alt="Back icon" />
            </div>
          </div>
          <div class="mt-4 lg:mt-8 text-grey-5 flex justify-between items-center w-full">
            <div>
              <div
                class="w-auto font-aktiv-grotesk-medium text-[12px] leading-[20px] uppercase text-center rounded-xl p-1 inline-block text-black bg-yellow"
                :class="{
                  'bg-orange': isOrange,
                  'bg-black': isBlack,
                  'bg-blue': isDarkBlue,
                  'bg-yellow text-grey-100': isYellow,
                }"
              >
                {{ event.label }}
              </div>
            </div>
            <!-- TODO update live voice link control-->
            <in-app-browser
              v-if="sessionMaterials.enableLiveVoice && !isAbsentAlumni"
              :href="sessionMaterials.liveVoiceLink"
              target="_blank"
              :class="{
                'pointer-events-none': !sessionMaterials.enableLiveVoice,
              }"
            >
              <div
                class="flex cursor-pointer items-center font-aktiv-grotesk border-[1.5px] rounded-xl font-bold text-[14px] leading-[20px] px-4 py-[10px] active:bg-lightblue active:border-lightblue"
                :class="
                  !sessionMaterials.enableLiveVoice
                    ? 'bg-grey-90 border-grey-90 text-grey-70'
                    : 'border-white'
                "
              >
                <img
                  src="../../../../public/assets/icons/live-voice-icon.svg"
                  class="pr-2"
                  :class="!sessionMaterials.enableLiveVoice ? 'opacity-[0.25]' : ''"
                />
                Access LiveVoice
              </div>
            </in-app-browser>
          </div>
          <div
            class="mt-4 lg:mt-8 text-grey-5 font-aktiv-grotesk-medium text-[20px] leading-[24px]"
          >
            {{ event.title }}
          </div>
          <div class="flex mb-1 mt-2 ml-2 lg:mb-2 lg:mt-4 lg:ml-4 justify-start items-start">
            <img
              v-if="isOrange"
              src="../../../../public/assets/icons/event-location-icon-orange.svg"
              alt="icon"
              class="mt-1"
            />
            <img
              v-else
              src="../../../../public/assets/icons/event-location-icon-blue.svg"
              alt="icon"
              class="mt-1"
            />
            <p
              v-for="place in event.location"
              :key="place"
              class="tracking-wide w-[300px] max-w-[300px] font-aktiv-grotesk-trial text-[14px] leading-[20px] ml-2 lg:ml-4 text-grey-5"
            >
              {{ place }}
            </p>
          </div>
        </div>
      </div>
      <div class="flex-1 pl-5 py-5 ml-2 lg:m-4">
        <div
          v-if="materialsCount > 0"
          class="tracking-wide font-aktiv-grotesk-medium text-[24px] leading-[32px] mt-2 lg:mt-4 text-black mb-6"
        >
          Session Resources
        </div>
        <div v-if="showAudio()" class="w-full mb-10 pr-5 mr-2">
          <div
            class="tracking-wide font-aktiv-grotesk-medium text-[20px] leading-[24px] text-black mb-4"
          >
            Audio Sermon
          </div>
          <img
            class="w-full md:w-[328px] rounded-[16px] mb-3"
            src="../../../../public/assets/images/BC-Redeem-Thumbnail.jpg"
          />
          <audio
            controls
            controlsList="nodownload"
            oncontextmenu="return false;"
            src="https://generations-assets.s3.ap-southeast-1.amazonaws.com/Redeeming+the+Office+of+the+Pastor+(Part+1)+.mp3"
            class="w-full md:w-[328px]"
          >
            Your browser does not support the <code>audio</code> element.
          </audio>
          <p class="w-full mt-3 md:w-[328px]">
            Listen to the message on
            <b>Redeeming the Office of the Pastor (Part 1)</b> by Pastor How. (Preached during
            GenerationS Conference 2022)
          </p>
        </div>
        <section v-if="materialsCount > 0">
          <div v-for="(asset, type) in assets" :key="type">
            <div class="mb-12" v-if="asset.materials.length > 0">
              <div
                class="tracking-wide font-aktiv-grotesk-medium text-[20px] leading-[24px] text-black mb-4"
              >
                {{ asset.header }}
              </div>
              <div class="flex flex-col pr-5 mr-2">
                <div
                  v-for="(material, index) in asset.materials"
                  :key="index"
                  class="md:hidden w-full md:mb-0"
                  :class="index === asset.materials.length - 1 ? 'mb-0' : 'mb-10'"
                >
                  <in-app-browser
                    v-if="!asset.header.includes('Questions') && material.externalLink"
                    :href="material.externalLink"
                    target="_blank"
                    rel="noreferrer noopener"
                    :data-test-id="material.dataTestId"
                    class="block relative w-full hover:opacity-90"
                  >
                    <img
                      class="rounded-[16px] w-full aspect-video"
                      :class="asset.header.includes('Tools') ? 'tool-shadow' : 'shadow'"
                      :src="material.thumbnail.url"
                      :alt="material.description"
                    />

                    <div
                      v-if="material.isVideo"
                      class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
                    >
                      <img
                        src="../../../../public/assets/icons/youtube-player/play-button-dark.svg"
                        class="w-10 h-10 lg:w-[48px] lg:h-[48px]"
                      />
                    </div>
                  </in-app-browser>
                  <router-link
                    v-if="!asset.header.includes('Questions') && !material.externalLink"
                    :to="`/resources/video/${material.slug}`"
                    rel="noreferrer noopener"
                    :data-test-id="material.dataTestId"
                    class="block relative w-full hover:opacity-90"
                  >
                    <img
                      class="rounded-[16px] w-full aspect-video"
                      :class="asset.header.includes('Tools') ? 'tool-shadow' : 'shadow'"
                      :src="material.thumbnail.url"
                      :alt="material.description"
                    />

                    <div
                      v-if="material.isVideo"
                      class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
                    >
                      <img
                        src="../../../../public/assets/icons/youtube-player/play-button-dark.svg"
                        class="w-10 h-10 lg:w-[48px] lg:h-[48px]"
                      />
                    </div>
                  </router-link>
                  <div v-if="!asset.header.includes('Questions')">
                    <p
                      v-if="material.description"
                      v-html="material.description"
                      class="w-full mt-3 break-words"
                    ></p>
                  </div>
                  <div v-if="asset.header.includes('Questions')">
                    <p
                      v-if="material.description"
                      v-html="material.description"
                      class="bg-grey-10 w-full rounded-2xl p-3 text-[14px] leading-[24px] font-aktiv-grotesk"
                    ></p>
                  </div>
                  <div
                    v-if="material.externalLinkTc || material.externalLinkTh"
                    class="flex justify-center gap-3 select-none mt-3"
                  >
                    <in-app-browser
                      v-if="material.externalLinkTc"
                      :href="material.externalLinkTc"
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      <div
                        class="flex flex-row justify-center items-center h-[40px] w-[120px] gap-2.5 box-border border-2 border-lightblue rounded-[100px] text-lightblue active:bg-lightblue download-button text-base active:text-[#FFFFFF]"
                      >
                        <span class="">繁体中文</span>
                        <!-- <span class="text-base">{{ itemName }}</span> -->
                        <svg
                          width="17"
                          height="16"
                          viewBox="0 0 17 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2.5 16C1.95 16 1.479 15.804 1.087 15.412C0.695002 15.02 0.499335 14.5493 0.500002 14V11H2.5V14H14.5V11H16.5V14C16.5 14.55 16.304 15.021 15.912 15.413C15.52 15.805 15.0493 16.0007 14.5 16H2.5ZM8.5 12L3.5 7L4.9 5.55L7.5 8.15V0L9.5 0V8.15L12.1 5.55L13.5 7L8.5 12Z"
                          />
                        </svg>
                      </div>
                    </in-app-browser>
                    <in-app-browser
                      v-if="material.externalLinkTh"
                      :href="material.externalLinkTh"
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      <div
                        class="flex flex-row justify-center items-center h-[40px] w-[120px] gap-2.5 box-border border-2 border-lightblue rounded-[100px] text-lightblue active:bg-lightblue download-button text-base active:text-[#FFFFFF]"
                      >
                        <span class="">ไทย</span>
                        <!-- <span class="text-base">{{ itemName }}</span> -->
                        <svg
                          width="17"
                          height="16"
                          viewBox="0 0 17 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2.5 16C1.95 16 1.479 15.804 1.087 15.412C0.695002 15.02 0.499335 14.5493 0.500002 14V11H2.5V14H14.5V11H16.5V14C16.5 14.55 16.304 15.021 15.912 15.413C15.52 15.805 15.0493 16.0007 14.5 16H2.5ZM8.5 12L3.5 7L4.9 5.55L7.5 8.15V0L9.5 0V8.15L12.1 5.55L13.5 7L8.5 12Z"
                          />
                        </svg>
                      </div>
                    </in-app-browser>
                  </div>
                </div>
                <div class="relative hidden md:block">
                  <swiper
                    :modules="modules"
                    :ref="'mySwiper' + asset.header"
                    class="mx-auto relative overflow-hidden"
                    :slides-per-view="swiperOptions.slidesPerView"
                    :centered-slides="swiperOptions.centeredSlides"
                    :grab-cursor="swiperOptions.grabCursor"
                    :pagination="swiperOptions.pagination"
                    @swiper="setSwiperInstance($event, asset.header)"
                  >
                    <swiper-slide
                      v-for="(material, index) in asset.materials"
                      :key="index"
                      class="rounded-2xl mr-3 lg:mr-6"
                    >
                      <div class="w-[327px] md:mr-6">
                        <in-app-browser
                          v-if="!asset.header.includes('Questions') && material.externalLink"
                          :href="material.externalLink"
                          target="_blank"
                          rel="noreferrer noopener"
                          :data-test-id="material.dataTestId"
                          class="block relative w-full sm:w-max mb-3 hover:opacity-90"
                        >
                          <img
                            class="rounded-[16px] w-full aspect-video sm:w-[328px]"
                            :class="asset.header.includes('Tools') ? 'tool-shadow' : 'shadow'"
                            :src="material.thumbnail.url"
                            :alt="material.description"
                          />

                          <div
                            v-if="material.isVideo"
                            class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
                          >
                            <img
                              src="../../../../public/assets/icons/youtube-player/play-button-dark.svg"
                              class="w-10 h-10 lg:w-[48px] lg:h-[48px]"
                            />
                          </div>
                        </in-app-browser>
                        <router-link
                          v-if="!asset.header.includes('Questions') && !material.externalLink"
                          :to="`/resources/video/${material.slug}`"
                          rel="noreferrer noopener"
                          :data-test-id="material.dataTestId"
                          class="block relative w-full sm:w-max mb-3 hover:opacity-90"
                        >
                          <img
                            class="rounded-[16px] w-full aspect-video sm:w-[328px]"
                            :class="asset.header.includes('Tools') ? 'tool-shadow' : 'shadow'"
                            :src="material.thumbnail.url"
                            :alt="material.description"
                          />

                          <div
                            v-if="material.isVideo"
                            class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
                          >
                            <img
                              src="../../../../public/assets/icons/youtube-player/play-button-dark.svg"
                              class="w-10 h-10 lg:w-[48px] lg:h-[48px]"
                            />
                          </div>
                        </router-link>

                        <div v-if="!asset.header.includes('Questions')">
                          <p
                            v-if="material.description"
                            v-html="material.description"
                            class="w-full mt-3 break-words"
                          ></p>
                        </div>
                        <div v-if="asset.header.includes('Questions')">
                          <p
                            v-if="material.description"
                            v-html="material.description"
                            class="bg-grey-10 rounded-2xl p-3 text-[14px] leading-[24px] font-aktiv-grotesk"
                          ></p>
                        </div>
                      </div>
                    </swiper-slide>
                  </swiper>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div v-else v-show="loading" class="flex items-center justify-center">
          <loading-state />
        </div>
      </div>
    </div>
  </master-layout>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Pagination, EffectCoverflow } from 'swiper/modules';
import { mapState, mapGetters } from 'vuex';
import platformMixin from '@/mixins/platformMixin';
import LoadingState from '@/components/common/LoadingState.vue';
import { FirebaseAnalytics } from '@/utils/firebase-analytics-wrapper';

export default {
  mixins: [platformMixin],
  components: {
    Swiper,
    SwiperSlide,
    LoadingState,
  },
  data() {
    return {
      swipers: {},
      event: {},
      materialsCount: 0,
      images: [],
      assets: {
        pdf: {
          header: 'Tools',
          materials: [],
        },
        questions: {
          header: 'Discussion Time Questions',
          materials: [],
        },
        links: {
          header: 'Related Resources',
          materials: [],
        },
      },
      swiperOptions: {
        centeredSlides: false,
        slidesPerView: 'auto',
        grabCursor: true,
        pagination: {
          el: '.swiper-pagination',
        },
      },
      modules: [Pagination, EffectCoverflow],
      showAudioFlag: false,
    };
  },
  computed: {
    ...mapState('user', ['token']),
    ...mapGetters('profile', ['isAbsentAlumni']),
    ...mapState('cms', ['sessionMaterials', 'loading', 'audioFlag']),
    ...mapState('livevoice', ['livevoiceSession']),
    ...mapState('schedule', ['GPCScheduleDates']),

    isOrange() {
      return this.labelColor === 'orange';
    },
    isDarkBlue() {
      return this.labelColor === 'dark-blue';
    },
    isBlack() {
      return this.labelColor === 'black';
    },
    isYellow() {
      return this.labelColor === 'yellow';
    },
    labelColor() {
      // Handle scenario: where no label
      if (!this.event.label) return '';

      // Below code: all has label
      // Handle scenario: where weekday
      if (this.isWeekday && this.event.type === 'experience') return 'black';
      if (this.isWeekday) return 'yellow';

      // Below all is weekend
      if (this.event.type === 'experience') return 'dark-blue';
      return 'yellow';
    },
    isWeekday() {
      // check if dateStr is weekday or weekend using moment
      // 0 is Sunday, 6 is Saturday
      const day = moment(new Date(this.event.startTime)).day();
      return day !== 0 && day !== 6;
    },
  },
  async ionViewWillEnter() {
    const sessionId = this.$route.params.name;
    await this.$store.dispatch('livevoice/fetchLivevoiceSession', sessionId);

    if (sessionId === 10) {
      await this.$store.dispatch('cms/fetchAudioFlag');
      this.showAudioFlag = this.audioFlag;
    } else {
      this.showAudioFlag = false;
    }

    await this.$store.dispatch('cms/fetchSessionMaterials', {
      sessionId: sessionId,
      conferenceType: 'Global',
    });

    // if (!(this.sessionMaterials.quotes.length == 0)) {
    //   this.images = this.sessionMaterials.quotes;
    //   this.materialsCount += this.sessionMaterials.quotes.length;
    // }

    if (!(this.sessionMaterials.tools.length === 0)) {
      this.assets.pdf.materials = this.sessionMaterials.tools;
      this.materialsCount += this.sessionMaterials.tools.length;
    }

    if (!(this.sessionMaterials.questions.length === 0)) {
      this.assets.questions.materials = this.sessionMaterials.questions;
      this.materialsCount += this.sessionMaterials.questions.length;
    }

    if (
      !(this.sessionMaterials.relatedResources.length === 0) ||
      !(this.sessionMaterials.gpc_videos.length === 0)
    ) {
      this.assets.links.materials = this.sessionMaterials.relatedResources;
      this.materialsCount += this.sessionMaterials.relatedResources.length;
      for (const key in this.sessionMaterials.gpc_videos) {
        this.assets.links.materials.push(this.sessionMaterials.gpc_videos[key]);
      }
      this.assets.links.materials.sort((a, b) => a.priority - b.priority);
    }

    this.fetch();

    this.updateCarousel();
    FirebaseAnalytics.setScreenName({
      screenName: 'session material - session ' + sessionId,
      nameOverride: 'Session Material - Session ' + sessionId,
    });
  },
  methods: {
    updateCarousel() {
      if (this.$refs['quotes-carousel']) this.$refs['quotes-carousel'].update();

      for (const header in this.swipers) {
        const swiper = this.swipers[header];
        swiper.update();
      }
    },
    back() {
      this.$router.go(-1);
    },
    showAudio() {
      return this.showAudioFlag;
    },
    async fetch() {
      const id = this.$route.params.name;
      const result = await axios.get(process.env.VUE_APP_API_URL + '/cms/schedules/byId/' + id, {
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
      });

      this.event = result.data[0];
    },
    setSwiperInstance(instance, header) {
      this.swipers[header] = instance;
    },
  },
};
</script>

<style scoped>
.top {
  background: url('../../../../public/assets/images/background-session-card.png');
  height: 481px;
  width: 100%;
  position: relative;
}

.typeform {
  padding-left: 32px;
  padding-top: 72px;
}

.session-bg {
  background-size: cover;
}

.swiper-slide {
  max-width: 328px;
  align-items: flex-start;
  vertical-align: middle;
  border-radius: 10px;
  display: flex;
  -webkit-transition: all 0.4s ease;
  transition: all 0.4s ease;
}

.swiper {
  list-style: none;
  z-index: 1;
  padding-bottom: 0px;
}

::v-deep(.swiper-wrapper) {
  padding-left: 0;
}

.download-button svg {
  fill: #00aae4;
}

.download-button:active svg {
  fill: #ffffff;
}

.tool-shadow {
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
}

.shadow {
  box-shadow: 0px 1px 25px 0px rgba(0, 0, 0, 0.25);
}
</style>
